<svelte:options runes={true} />

<script lang="ts">
  import * as Shoelace from '@shoelace-style/shoelace';
  import '@shoelace-style/shoelace/dist/components/icon/icon.js';
  import type { AppIcon } from '@ui';
  import { SlFontSize } from '@ui';

  let {
    icon,
    size,
    inline: inline
  }: {
    icon: AppIcon;
    size?: SlFontSize;
    inline?: boolean;
  } = $props();

  let element: HTMLElement;

  function fontSize(): string {
    if (size === undefined) {
      return `inherit`;
    } else {
      return `var(${size})`;
    }
  }

  function display(): string {
    return inline ? 'inline-block' : 'block';
  }

  const slIcon: Shoelace.SlIcon = Object.assign(document.createElement('sl-icon'), {
    library: icon.library,
    name: icon.name,
    style: `display: ${display()}; vertical-align: middle; font-size: ${fontSize()};`
  });

  $effect(() => {
    element.appendChild(slIcon);
  });
</script>

<span bind:this={element}> </span>
